import axios from "../axios";
import { setAlert } from "actions/alert";
import { THEMECOLOR } from "constants/api";
import { GET_THEMECOLOR, LOADING_ON_THEMECOLOR_SUBMIT, THEMECOLOR_ERROR, THEMECOLOR_UPDATED, REMOVE_ERRORS, LOAD_THEMECOLOR, LOADING_THEMECOLOR } from "actions/types";
import { setErrorsList } from "actions/errors";
import { logout } from "actions/auth";

export const updateThemeColor = (formData, history, _id) => async (dispatch) => {
    dispatch({ type: REMOVE_ERRORS });
    dispatch({ type: LOADING_ON_THEMECOLOR_SUBMIT });

    const config = {
        headers: {
            "Content-Type": "application/json",
        },
    };
    try {
        const res = await axios.put(`${THEMECOLOR.UPDATE_THEMECOLOR().ENDPOINT}`, formData, config);
        if (res.data.status === true) {
            dispatch({
                type: THEMECOLOR_UPDATED,
                payload: res.data.response,
            });
            dispatch(
                setAlert(res.data.message, "success")
            );
        } else {
            const errors = res.data.errors;
            if (errors) {
                dispatch({
                    type: THEMECOLOR_ERROR,
                });
                dispatch(setAlert(res.data.message, "danger"));
                errors.forEach((error) => {
                    dispatch(setErrorsList(error.msg, error.param));
                });
            }
        }
        return res.data ? res.data : { status: false };
    } catch (err) {
        if (err.response) {
            if (err.response.data && err.response.data.tokenStatus === 0) {
                dispatch(logout());
            } else {
                dispatch({
                    type: THEMECOLOR_ERROR,
                    payload: {
                        msg: err.response.statusText,
                        status: err.response.status,
                    },
                });
                dispatch(
                    setAlert(
                        err.response.data.message || err.response.statusText,
                        "danger"
                    )
                );
            }
        }
    }
}

export const getThemeColor = () => async (dispatch) => {
    dispatch({ type: REMOVE_ERRORS });
    dispatch({ type: LOADING_THEMECOLOR });
    try {
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };
        const res = await axios.get(
            `${THEMECOLOR.UPDATE_THEMECOLOR().ENDPOINT}`,
            config
        );
        // dispatch({ type: REMOVE_ALERT });

        await dispatch({
            type: GET_THEMECOLOR,
            payload: res.data.response,
        });
        return res.data ? res.data.response : { status: false };
    } catch (err) {
        // console.log(err);
        if (err.response) {
            if (err.response.data && err.response.data.tokenStatus === 0) {
                dispatch(logout());
            } else {
                dispatch({
                    type: THEMECOLOR_ERROR,
                    payload: {
                        msg: err.response.statusText,
                        status: err.response.status,
                    },
                });
                dispatch(
                    setAlert(
                        err.response.data.message || err.response.statusText,
                        "danger"
                    )
                );
            }
        }
    }
};
// reset errors
export const removeErrors = () => async (dispatch) => {
    dispatch({ type: REMOVE_ERRORS });
};

export const setErrors = (errors) => async (dispatch) => {
    if (errors) {
        dispatch({ type: THEMECOLOR_ERROR });
        dispatch(setAlert("Please correct the following errors", "danger"));
        errors.forEach((error) => {
            dispatch(setErrorsList(error.msg, error.param));
        });
    }
};

export const loadingThemeColor = () => async (dispatch) => {
    await dispatch({ type: LOAD_THEMECOLOR });
};